import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  setVideoinputDevices,
  setAudioinputDevices,
  setAudiooutputDevices,
} from '../store/slices/deviceSlice';
import {
  setVideoError,
  setMicrophoneError,
  setSpeakerError,
} from '../store/slices/statusSlice';

const useDevicePermissions = (streamHandler, checkedPermission) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (!checkedPermission.audio || !checkedPermission.video) return;

    const fetchDevices = async () => {
      let tryIdx = 0;
      let devices = [];
      let noLabels = true;

      while (tryIdx < 5 && noLabels) {
        devices = await streamHandler.getDevices();
        noLabels = devices.every((d) => !d.label);

        if (noLabels) {
          tryIdx++;
          await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for 100ms before the next attempt
        }
      }

      const cameraDevices = devices.filter(
        (d) => d.kind === 'videoinput' && d.deviceId !== ''
      );
      const microphoneDevices = devices.filter(
        (d) => d.kind === 'audioinput' && d.deviceId !== ''
      );

      const speakerDevices = devices.filter(
        (d) => d.kind === 'audiooutput' && d.deviceId !== ''
      );

      if (speakerDevices.length === 0) {
        // Set the default audio output device
        speakerDevices.push({
          deviceId: 'notsupported',
          groupId: 'default',
          label: t('Default'),
        });
      }

      dispatch(setVideoinputDevices(cameraDevices));
      dispatch(setAudioinputDevices(microphoneDevices));
      dispatch(setAudiooutputDevices(speakerDevices));

      if (cameraDevices.length === 0) {
        dispatch(setVideoError('noCamera'));
      }
      if (microphoneDevices.length === 0) {
        dispatch(setMicrophoneError('noMicrophone'));
      }
      if (speakerDevices.length === 0) {
        dispatch(setSpeakerError('noSpeaker'));
      }
    };

    fetchDevices();
  }, [checkedPermission, dispatch, streamHandler, t]);
};

export default useDevicePermissions;
